import { Box } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import StarCardLoading from '../../components/feedback/StarCardLoading';
import useOtpFlow from '../../hooks/useOtpFlow';
import { useAppStore } from '../../stores/appStore';
import RegisterForm from './components/RegisterForm';
import RegisterOTP from './components/RegisterOTP';
import RegisterPhone from './components/RegisterPhone';

const RegisterPage = () => {
  const appLoading = useAppStore((state) => state.appLoading);

  const {
    activeStep,
    setActiveStep,
    phoneNumber,
    setPhoneNumber,
    isLoadingRequestOtp,
    isLoadingVerifyOtp,
    handleRequestOtp,
    handleRequestOtpAgain,
    handleVerifyOtp,
    handleChangeStep,
  } = useOtpFlow();

  if (appLoading) {
    return <StarCardLoading />;
  }

  return (
    <>
      <Helmet>
        <title>Register | Caltex StarCard</title>
      </Helmet>

      <Box component="main" maxWidth="md" mx="auto">
        <Box component="section" p="0">
          {activeStep === 1 && (
            <RegisterPhone
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              isLoading={isLoadingRequestOtp}
              onSubmit={handleRequestOtp}
            />
          )}
          {activeStep === 2 && (
            <RegisterOTP
              onBack={() => handleChangeStep(1)}
              onResend={handleRequestOtpAgain}
              onVerify={handleVerifyOtp}
              isLoading={isLoadingVerifyOtp}
            />
          )}

          {activeStep === 3 && (
            <RegisterForm
              phoneNumber={phoneNumber}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default RegisterPage;
